import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import ItineraryDay from './ItineraryDay';
import ItineraryMap from './ItineraryMap';

const Itinerary = ({ itineraryDays, sailingItineraryMapImageUrl }) => (
  <div className="grid grid-cols-3 gap-5 mx-2 md:mx-10 my-5 pb-5">
    <ItineraryMap sailingItineraryMapImageUrl={sailingItineraryMapImageUrl} />
    <div className={sailingItineraryMapImageUrl ? 'col-span-2' : 'col-span-3'}>
      {itineraryDays && itineraryDays.map((destination, index) => (
        <ItineraryDay
          destination={destination}
          index={index}
          itineraryDays={itineraryDays}
          key={destination.itineraryDayNumber + destination.cityName}
        />
      ))}
      {!itineraryDays && (
        <div className="text-center">
          <CircularProgress color="secondary" />
        </div>
      )}
    </div>
  </div>
);

Itinerary.propTypes = {
  itineraryDays: PropTypes.arrayOf(PropTypes.shape()),
  sailingItineraryMapImageUrl: PropTypes.string,
};

Itinerary.defaultProps = {
  itineraryDays: undefined,
  sailingItineraryMapImageUrl: undefined,
};

export default Itinerary;
